import Vue from 'vue';
import Vuetify from 'vuetify/lib';
/* eslint-disable */
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const options = {
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#263238',
                secondary: colors.grey.darken1,
                accent: colors.shades.black,
                error: colors.red.accent3,
                background: "#ff0000",
                // primary: '#1976D2',
                // secondary: '#424242',
                // accent: '#82B1FF',
                // error: '#FF5252',
                // info: '#2196F3',
                // success: '#4CAF50',
                // warning: '#FFC107',
            },
            dark: {
                // base: "#1A2034",
                primary: colors.blueGrey.lighten5,
                secondary: "#ff0000",
                background: "#ffffff",
                // background: "radial-gradient(ellipse at bottom, #37474F 0%, #263238 100%)",
                // sideNavPanel: 'radial-gradient(ellipse at bottom, #0d1d31 0%, #0c0d13 100%)',
                anchor: '#8c9eff',
                // primary: '#1976D2',
                // secondary: '#424242',
                // accent: '#82B1FF',
                // error: '#FF5252',
                // info: '#2196F3',
                // success: '#4CAF50',
                // warning: '#FFC107',
            },
        },
    },
}

export default new Vuetify(options);
